import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getUsersContent = createAsyncThunk(
  "/users",
  async ({ account }) => {
    const { data } = await axios.get(`/api/accounts/${account}/users`, {});
    return { data };
  }
);

export const orgSlice = createSlice({
  name: "org",
  initialState: {
    isLoading: false,
    users: null,
  },
  reducers: {},

  extraReducers: {
    [getUsersContent.pending]: (state) => {
      state.isLoading = true;
    },
    [getUsersContent.fulfilled]: (state, action) => {
      const { users } = action.payload.data;
      state.users = users;
      state.isLoading = false;
    },
    [getUsersContent.rejected]: (state) => {
      state.isLoading = false;
    },
  },
});

export const { addNewLead } = orgSlice.actions;

export default orgSlice.reducer;
